// type="number" inputs report "" when emptied; nullable columns store blank as null.
export const toNullableNumber = (value: unknown) =>
  value === "" || value === null || value === undefined ? null : Number(value);
